import { Chip } from '@sorare/core/src/atoms/ui/Chip';

type Props = {
  gameWeek?: string;
};
export const GameWeekChip = ({ gameWeek }: Props) => {
  if (!gameWeek) return null;
  return (
    <Chip
      custom={{
        color: 'var(--c-neutral-1000)',
        background: 'var(--c-neutral-400)',
      }}
      size="smaller"
      label={gameWeek}
    />
  );
};
